import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import { createAppRouter } from '@/app/router'
import { AppearanceProvider } from '@/shared/appearance/AppearanceProvider'
import { I18nProvider } from '@/shared/i18n/I18nProvider'

import './styles/app.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
})

const container = document.getElementById('root')
if (!container) {
  throw new Error('root container is missing from the document')
}

const router = createAppRouter({ queryClient })
createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <I18nProvider>
        <AppearanceProvider>
          <RouterProvider router={router} />
        </AppearanceProvider>
      </I18nProvider>
    </QueryClientProvider>
  </StrictMode>,
)
